<template>
  <Flex
    align="center"
    justify="center"
    :gap=".5"
  >
    <div :class="$style.base">
      <div
        :class="$style.progress"
        :style="{ width: `${roundedPercentage}%` }"
        v-test="'_base-progressbar-inner'"
      />
    </div>
    <BaseText v-test="'_base-progressbar-percentage'"
      >{{ roundedPercentage }}%</BaseText
    >
  </Flex>
</template>

<script
  setup
  lang="ts"
>
const props = defineProps<{
  percentage: number;
}>();

const roundedPercentage = computed(() => Math.round(props.percentage));
</script>

<style module>
.base {
  width: 200px;
  max-width: 100%;
  height: 8px;
  background-color: var(--neutral-soft);
  border-radius: 20px;
}

.progress {
  height: 100%;
  background-color: var(--action-primary);
  border-radius: inherit;
  transition: width 0.3s ease-in-out;
}
</style>
